module.exports = __webpack_public_path__ + "img/sphone_access.806ca3dd.png";